@if (info) {
  <div class="new-blog">
    <div class="category-list">
      @if (info.dateFrom  || info.dateTo ) {
        <mat-chip-listbox class="chip-dates">
          <mat-chip-option>{{info.dateFrom ? info.dateFrom : '-'}}</mat-chip-option> -
          <mat-chip-option>{{info.dateTo ? info.dateTo : '-'}}</mat-chip-option>
        </mat-chip-listbox>
      }
      @if (info.blogType) {
        <mat-chip-listbox class="chip-listbox">
          <mat-chip-option color="primary" selected>{{info.blogType.name}}</mat-chip-option>
        </mat-chip-listbox>
      }
    </div>
    @if (info.image) {
      <div  class="image">
        <img src="{{info?.image}}">
      </div>
    }
    @if (videoUrl && !info.image) {
      <div >
        <iframe [src]="videoUrl" class="video">
        </iframe>
      </div>
    }
    <app-header-one [color]="'#A3A3A3'" [title]="info.date" [date]="'Blog'"
    [textColor]="'black'" [type]="'blog'"></app-header-one>
    <div class="main-info" [ngClass]="{'no-image' : !info.image && !videoUrl}">
      <div class="main-info-title">
        {{info?.title}}
      </div>
      @if (info.text) {
        <div class="text" [innerHTML]="info.text">
        </div>
      }
      @if (info.link && ((!info.text && info.image) || (info.text && !info.image))) {
        <div class="link">
          <a href="{{info.link | linkHttp}}" target="_blank">{{info.linkLabel}}</a>
        </div>
      }
    </div>
  </div>
}
@if (info) {
  <div class="block-footer">
    <div class="block-footer-1">
    </div>
    <div class="block-footer-2">
      <div class="block-footer-2-1">
      </div>
    </div>
  </div>
}
